<template>
  <CaseStudy
    title="HAWK"
    :logo="require('@/assets/logos/hawk.png')"
    :thumbnail="require('@/assets/screenshots/hawk.png')"
    iframeLink="https://iframe.bubblemaps.io/map/YiWNcmo8WNC8NiiRkfJh?partnerId=demo"
    threadLink="https://x.com/bubblemaps/status/1864439521523196046"
    :featuredIn="[
      {
        name: 'Fortune',
        logo: require('@/assets/logos/medias/fortune.png'),
        link: 'https://fortune.com/crypto/2024/12/10/hawk-tuah-memecoin-launch-haliey-welch-pump-dump-rug-pull',
      },
      {
        name: 'New York Post',
        logo: require('@/assets/logos/medias/newyorkpost.png'),
        link: 'https://nypost.com/2024/12/05/business/hawk-tuah-girl-haliey-welch-launches-cryptocurrency-which-crashes-shortly-after-launch',
        color: '#B62819',
      },
      {
        name: 'Forbes',
        logo: require('@/assets/logos/medias/forbes.png'),
        link: 'https://www.forbes.com/sites/conormurray/2024/12/05/hawk-tuah-creator-haliey-welch-criticized-for-chaotic-memecoin-launch-in-latest-bizarre-internet-stunt/',
        color: '#498ef5',
      },
    ]"
  >
    How Hailey Welch’s HAWK token collapsed after insiders
    <b>dumped 16% of the supply</b>, exposing the risks of celebrity-led
    presales
  </CaseStudy>
</template>

<script>
import CaseStudy from "@/components/organisms/CaseStudies/CaseStudy.vue";

export default {
  components: {
    CaseStudy,
  },
};
</script>
